import PropTypes from 'prop-types';
import React from 'react';
import {View} from 'react-native';

const DoughnutWrapper = props => {
  return (
    <View style={{
      height: props.size, 
      width: props.size,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'transparent',
    }}>
      {props.children}
    </View>
  );
};

export default DoughnutWrapper;